import { GameStateEnums } from '../../../../../shared/GameEnums.ts';
import { MechanicValidatorLongestRoad } from '@colonist/game-mechanic-validators';
import { PlayerColor } from '@colonist/game-states';
const UIGameEventEnums = GameStateEnums.UIGameEventEnums;
export class UIGameLongestRoadController {
    onEvent(data, eventType) {
        switch(eventType){
            case UIGameEventEnums.PlayerControllerStateUpdated:
                this.updateLongestRoadStatus(data);
                break;
            default:
                break;
        }
    }
    updateLongestRoadStatus(animate) {
        this.resetLastLongestRoadIfNoPlayerHasLongestRoad();
        for (const player of this.uiGameManager.gameState.players){
            const longestRoadPlayerState = this.longestRoadValidator.getLongestRoadPlayerState(player.color);
            if (!longestRoadPlayerState.hasLongestRoad) continue;
            if (player.color == this.lastPlayerToHoldLongestRoad) continue;
            this.playerAchievedLongestRoad(player, animate);
        }
    }
    resetLastLongestRoadIfNoPlayerHasLongestRoad() {
        for (const player of this.uiGameManager.gameState.players){
            const longestRoadPlayerState = this.longestRoadValidator.getLongestRoadPlayerState(player.color);
            if (longestRoadPlayerState.hasLongestRoad) return;
        }
        this.lastPlayerToHoldLongestRoad = PlayerColor.None;
    }
    playerAchievedLongestRoad(playerState, animate) {
        const longestRoadPlayerState = this.longestRoadValidator.getLongestRoadPlayerState(playerState.color);
        const longestRoadScore = longestRoadPlayerState.longestRoad;
        const achievement = {
            achievementOwnerNew: playerState.color,
            achievementOwnerPrevious: this.lastPlayerToHoldLongestRoad,
            achievementScore: longestRoadScore,
            achievementType: 'LongestRoad'
        };
        this.lastPlayerToHoldLongestRoad = playerState.color;
        this.uiGameManager.eventController.sendEvent(achievement, UIGameEventEnums.PlayerReceivedAchievement);
    }
    constructor(uiGameManager, longestRoadState){
        this.uiGameManager = uiGameManager;
        this.uiGameManager.eventController.registerUIGameMechanic(this);
        this.longestRoadValidator = new MechanicValidatorLongestRoad(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, longestRoadState);
        this.lastPlayerToHoldLongestRoad = this.longestRoadValidator.getPlayerWithLongestRoadCard();
    }
}
